<template>
  <div id="app">
    <!-- Lobby 页面全屏显示，不需要顶部导航 -->
    <nav v-if="$route.name !== 'Lobby'" class="top-bar">
      <div class="logo" @click="$router.push('/')" style="cursor:pointer">EMOCHI 4399</div>
      <div class="nav-right">
        <template v-if="user">
          <img v-if="user.avatar_url" :src="user.avatar_url" class="avatar" />
          <span class="username">{{ user.nickname || user.username }}</span>
          <button @click="logout" class="btn-logout">登出</button>
        </template>
        <template v-else>
          <router-link to="/login" class="btn-login">登录</router-link>
        </template>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['user'])
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; background: #000; color: #eee; }
.top-bar {
  display: flex; justify-content: space-between; align-items: center;
  padding: 12px 24px; background: #16213e;
}
.logo { font-size: 16px; font-weight: 700; letter-spacing: 3px; }
.nav-right { display: flex; align-items: center; gap: 12px; }
.avatar { width: 32px; height: 32px; border-radius: 50%; }
.btn-login, .btn-logout {
  padding: 6px 16px; border-radius: 6px; cursor: pointer;
  text-decoration: none; font-size: 14px;
}
.btn-login { background: #e94560; color: #fff; }
.btn-logout { background: transparent; color: #aaa; border: 1px solid #555; }
</style>
